import { makeStyles } from 'tss-react/mui';
import { Modal, ModalContent } from '@uplift/ui-v2';

export type DiagnosisSearchModalProps = {
  children: React.ReactNode;
  onClose: () => void;
};

export const DiagnosisSearchModal: React.FC<DiagnosisSearchModalProps> = ({ children, onClose }) => {
  const { classes: modalClasses } = useStyles();

  return (
    <Modal
      open
      title=""
      classes={modalClasses}
      className="fs-exclude"
      maxWidth="md"
      onClose={onClose}
    >
      <ModalContent>
        {children}
      </ModalContent>
    </Modal>
  );
};

const useStyles = makeStyles()({
  paper: {
    height: '550px'
  },
  paperWidthMd: {
    width: '600px',
    maxWidth: '600px'
  },
  paperFullWidth: {
    width: '100%',
    maxWidth: 'initial',
  },
  paperFullScreen: {
    height: '100%'
  }
});
